import produce from 'immer';
import { DateTime } from 'luxon';

import {
    LAST_24_HOURS_VALUE,
    LAST_SIX_MONTHS_VALUE,
    ANOTHER_PERIOD_VALUE
} from '../constants';
import {
    LOAD_NEXT_PAGE,
    SET_ANOTHER_PERIOD,
    SET_PERIOD,
    TOGGLE_LOADING,
    UPDATE_HISTORY,
    SET_ERROR,
    EXPORT_HISTORY
} from './actions';

const initialEndDate = new Date();
const initialStartDate = DateTime.local()
    .minus({ days: LAST_24_HOURS_VALUE })
    .toJSDate();

export const defaultState = {
    transactions: [],
    isLoading: true,
    defaultTypeNames: {},
    startDate: initialStartDate,
    endDate: initialEndDate,
    isPreventFetchByAnotherPeriod: false,
    period: LAST_24_HOURS_VALUE,
    error: '',
    page: {
        pageId: 0,
        nextPageId: 0,
        isPageChanged: false,
        secondBulk: false
    },

    isExportLoading: false,
    exportError: ''
};

export const reducer = (reducerSuffix) => produce((draftState, action) => {
    switch (action.type) {
        case SET_PERIOD:
        case SET_PERIOD + reducerSuffix: {
            const { period, startDate, endDate } = action.payload;

            Object.assign(draftState, {
                period,
                page: {
                    ...draftState.page,
                    pageId: 0,
                    secondBulk: false,
                    isPageChanged: false
                },
                isPreventFetchByAnotherPeriod: period === ANOTHER_PERIOD_VALUE,
                ...period !== ANOTHER_PERIOD_VALUE && {
                    startDate,
                    endDate
                }
            });

            break;
        }

        case SET_ANOTHER_PERIOD:
        case SET_ANOTHER_PERIOD + reducerSuffix: {
            const { from, until } = action.payload;

            Object.assign(draftState, {
                startDate: from,
                endDate: until,
                isPreventFetchByAnotherPeriod: false,
                page: {
                    ...draftState.page,
                    pageId: 0,
                    secondBulk: false,
                    isPageChanged: false
                }
            });

            break;
        }

        case UPDATE_HISTORY:
        case UPDATE_HISTORY + reducerSuffix: {
            const {
                transactions: newTransactions,
                pagerResponse: { nextPageId },
                defaultTypeNames: newDefaultTypeNames
            } = action.payload;
            const secondBulk = draftState.page.secondBulk || Number(draftState.period) === LAST_SIX_MONTHS_VALUE && !nextPageId;

            const transactions = draftState.page.isPageChanged
                ? [...draftState.transactions, ...newTransactions]
                : newTransactions;

            const defaultTypeNames = draftState.page.isPageChanged
                ? { ...draftState.defaultTypeNames, ...newDefaultTypeNames }
                : newDefaultTypeNames;

            Object.assign(draftState, {
                page: {
                    ...draftState.page,
                    secondBulk,
                    pageId: !draftState.page.secondBulk && secondBulk && !nextPageId ? 0 : draftState.page.pageId,
                    isPageChanged: secondBulk || draftState.page.isPageChanged,
                    nextPageId
                },
                transactions,
                defaultTypeNames
            });

            break;
        }

        case LOAD_NEXT_PAGE:
        case LOAD_NEXT_PAGE + reducerSuffix: {
            Object.assign(draftState, {
                page: {
                    ...draftState.page,
                    pageId: draftState.page.nextPageId,
                    isPageChanged: true
                }
            });

            break;
        }

        case TOGGLE_LOADING:
        case TOGGLE_LOADING + reducerSuffix: {
            Object.assign(draftState, {
                isLoading: action.payload
            });

            break;
        }

        case SET_ERROR:
        case SET_ERROR + reducerSuffix: {
            const { error } = action.payload;

            Object.assign(draftState, {
                error
            });

            break;
        }

        case EXPORT_HISTORY:
        case EXPORT_HISTORY + reducerSuffix: {
            const { exportError, isExportLoading } = action.payload;

            Object.assign(draftState, {
                exportError,
                isExportLoading
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
